import React, { createContext, useContext } from "react";
import NotificationController from "components/Notifications/NotificationController";

export const notificationContext = createContext();

export function ProvideNotification({ children }) {
    const notifications = useProvideNotification();
    return (
        <notificationContext.Provider value={notifications}>
            {children}
        </notificationContext.Provider>
    );
}

export const useNotification = () => {
    return useContext(notificationContext);
};

function useProvideNotification() {
    const notificationController = new NotificationController();

    const show = (message, onClose = () => {}) => {
        notificationController.addNotification(message, onClose);
    };

    const hasNext = () => {
        return notificationController.hasNext();
    };

    const getNext = () => {
        return notificationController.getNext();
    };

    return {
        show,
        hasNext,
        getNext,
    };
}
